import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function AboutPage() {
 return (
  <StaticPageLayout title='About Us'>
   <p className='lead text-xl text-primary font-mono mb-8'>
    Building the future of technical interview preparation through advanced
    simulation.
   </p>

   <h3>Our Mission</h3>
   <p>
    MOCK.SYSTEM was founded with a singular goal: to democratize access to
    high-quality technical interview preparation. We believe that talent is
    distributed equally, but opportunity is not. By leveraging cutting-edge AI,
    we provide a realistic, rigorous, and constructive environment for engineers
    to master their craft.
   </p>

   <h3>The Technology</h3>
   <p>
    Our platform utilizes state-of-the-art Large Language Models (LLMs)
    fine-tuned on thousands of real-world technical interviews. This allows our
    AI interviewers to adapt to your responses, probe deeper into complex
    topics, and provide actionable feedback that goes beyond simple correctness.
   </p>

   <h3>The Team</h3>
   <p>
    We are a team of engineers, educators, and AI researchers passionate about
    helping others succeed. We've been on both sides of the interview table at
    top tech companies, and we've poured that experience into building
    MOCK.SYSTEM.
   </p>
  </StaticPageLayout>
 );
}
